import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { Info } from "components/icons/Info";
import { CallSummaryMarkdown } from "./CallSummaryMarkdown";

type CallSummaryViewModalProps = {
  isOpen: boolean;
  close: () => void;
  summary: string;
};

export const CallSummaryViewModal = ({
  isOpen,
  close,
  summary,
}: CallSummaryViewModalProps) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="regular">
        <Modal.Header>
          <Modal.Title>Call Summary</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <CallSummaryMarkdown text={summary} />
          <div className="t-flex t-gap-2 t-items-start t-mt-4">
            <span className="t-flex t-shrink-0 t-mt-0.5 t-text-text-30">
              <Info color="currentColor" stroke="1.2" size="16" />
            </span>
            <p className="t-text-body-sm t-text-text-30 t-mb-0 t-italic">
              This summary is AI-generated and may contain inaccuracies. Please
              verify important details before acting on them.
            </p>
          </div>
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button type="button" customType="secondary">
              Close
            </Button>
          </Modal.RawClose>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
